import { toRems } from "../../helpers/theme";

const style = ({ theme, hasSmallSpacing }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "auto",
    "& .drawerFooter_inner": {
        position: "relative",
        width: "100%",
        height: "100%",
        padding: toRems([0, theme.global.drawer.hSpacing.mobile, 30]),
        [theme.breakpoints.up("md")]: {
            padding: toRems([0, theme.global.drawer.hSpacing.desktop, hasSmallSpacing ? 30 : 60]),
        },
    },
});

export default style;
